import type { FC } from "react";
import { i18nFilter } from "app/filters/i18nFilter";
import type { ITableCellProps } from "../interfaces/ITableCellProps";

export const AdsenseCell: FC<Pick<ITableCellProps, "value"> & Partial<Pick<ITableCellProps, "tooltip">>> = ({
    value,
    tooltip,
}) => {
    return value ? (
        <div className="u-alignCenter">
            <i
                className="sw-icon-checkmark_circle"
                title={i18nFilter()(tooltip || "analysis.all.table.columns.googleAds.value.tooltip")}
            ></i>
        </div>
    ) : null;
};
AdsenseCell.displayName = "AdsenseCell";
